import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { 
  FiHome, FiUsers, FiBookOpen, FiFileText, FiSettings, 
  FiLogOut, FiMenu, FiCheckSquare, FiLayers 
} from 'react-icons/fi';

const AdminLayout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const navItems = [
    { icon: FiHome, label: 'لوحة التحكم', path: '/admin/dashboard' },
    { icon: FiUsers, label: 'المستخدمين', path: '/admin/users' },
    { icon: FiBookOpen, label: 'الكورسات', path: '/admin/courses' },
    { icon: FiLayers, label: 'الاشتراكات', path: '/admin/enrollments' },
    { icon: FiFileText, label: 'المقالات', path: '/admin/articles-list' },
    { icon: FiCheckSquare, label: 'الاختبارات', path: '/admin/quizzes' }, // Optional
    { icon: FiSettings, label: 'الإعدادات', path: '/admin/settings' },
  ];

  return (
    <div className="min-h-screen bg-gray-100 flex font-sans text-right" dir="rtl">
      
      {/* 1. SIDEBAR */}
      <aside 
        className={`bg-blue-900 text-white fixed lg:static inset-y-0 right-0 z-40 w-64 transform transition-transform duration-300 ease-in-out shadow-xl ${
          isSidebarOpen ? 'translate-x-0' : 'translate-x-full lg:translate-x-0 lg:w-20'
        }`}
      >
        <div className="h-full flex flex-col">
          {/* Logo Area */}
          <div className="h-16 flex items-center justify-center border-b border-blue-800">
             {isSidebarOpen ? (
               <h1 className="text-xl font-bold tracking-wider">iTalebTech <span className="text-blue-400 text-xs">ADMIN</span></h1>
             ) : (
               <span className="font-bold text-xl">iT</span>
             )}
          </div>

          {/* Navigation */}
          <nav className="flex-1 py-6 space-y-2 overflow-y-auto px-2">
            {navItems.map((item) => {
              const isActive = location.pathname.includes(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 group ${
                    isActive 
                      ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/20' 
                      : 'text-blue-200 hover:bg-blue-800 hover:text-white'
                  }`}
                  title={item.label}
                >
                  <item.icon size={20} className={`${isActive ? 'text-white' : 'text-blue-300 group-hover:text-white'}`} />
                  <span className={`font-medium whitespace-nowrap transition-all duration-200 ${!isSidebarOpen && 'hidden lg:hidden'}`}>
                    {item.label}
                  </span>
                </Link>
              );
            })}
          </nav>

          {/* Logout */}
          <div className="p-4 border-t border-blue-800">
            <button 
              onClick={handleLogout}
              className="flex items-center gap-3 w-full px-4 py-3 rounded-xl text-red-300 hover:bg-blue-800 hover:text-red-200 transition-colors"
            >
              <FiLogOut size={20} />
              <span className={`${!isSidebarOpen && 'hidden lg:hidden'}`}>تسجيل خروج</span>
            </button>
          </div>
        </div>
      </aside>

      {/* 2. MAIN CONTENT AREA */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        
        {/* Top Header */}
        <header className="bg-white shadow-sm h-16 flex items-center justify-between px-6 z-30">
          <button 
            onClick={() => setSidebarOpen(!isSidebarOpen)}
            className="p-2 rounded-lg hover:bg-gray-100 text-gray-600 focus:outline-none"
          >
            {isSidebarOpen ? <FiMenu size={24} /> : <FiMenu size={24} />}
          </button>
          
          <div className="flex items-center gap-4">
             <div className="text-sm text-gray-500">
               أهلاً، <span className="font-bold text-gray-900">المدير العام</span>
             </div>
             <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold border-2 border-white shadow-sm">
               A
             </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto p-6 lg:p-8">
           <Outlet /> {/* 👈 THIS IS CRITICAL: It renders the nested dashboard pages */}
        </main>

      </div>

      {/* Mobile Overlay */}
      {isSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default AdminLayout;